import { Link, Outlet, useLocation } from 'react-router-dom';
import { useBranding } from '../contexts/BrandingContext';
import ChatBot from '../components/ChatBot';

export default function PublicLayout() {
  const branding = useBranding();
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col bg-[#060a1f]">
      <header className={
        isHome
          ? 'bg-[#0a0e2a]/80 backdrop-blur-md border-b border-white/10 sticky top-0 z-50'
          : 'bg-[#0a0e2a] border-b border-white/10'
      }>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/images/maintenova-logo.png"
              alt={branding.brand_name}
              className="h-8"
            />
          </Link>
          <nav className="flex items-center gap-6 text-sm font-medium text-blue-100/70">
            <Link to="/pricing" className="hover:text-[#5ba4f5] transition-colors">Pricing</Link>
            <Link to="/blog" className="hover:text-[#5ba4f5] transition-colors">Blog</Link>
            <Link to="/changelog" className="hover:text-[#5ba4f5] transition-colors">Changelog</Link>
            <Link to="/kb" className="hover:text-[#5ba4f5] transition-colors">Knowledge Base</Link>
            <Link to="/contact" className="hover:text-[#5ba4f5] transition-colors">Contact</Link>
            <Link
              to="/login"
              className="text-xs py-1.5 px-3 bg-[#5ba4f5] text-white font-bold rounded-lg hover:bg-[#4a93e4] transition-colors"
            >
              Sign In
            </Link>
          </nav>
        </div>
      </header>

      <main className={`flex-1 ${isHome ? '' : 'max-w-5xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-10'}`}>
        <Outlet />
      </main>

      <footer className="bg-[#050820] border-t border-white/5">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col items-center gap-4">
          <Link to="/">
            <img src="/images/maintenova-logo.png" alt={branding.brand_name} className="h-6 opacity-60" />
          </Link>
          <p className="text-sm text-blue-200/40">
            &copy; {new Date().getFullYear()} {branding.brand_name}. All rights reserved.
          </p>
        </div>
      </footer>

      <ChatBot />
    </div>
  );
}
